<div class="flex-container overflow-auto h-100" fxLayout="row" fxLayoutAlign="start start" [dragula]="bagName" [dragulaModel]='lectures'>
  <app-lecture *ngFor="let lecture of lectures" [course]="course" [lecture]="lecture.$data | async" class="flex-item p-2 h-100 w-25"></app-lecture>
</div>





// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-list/lecture-list.component.html